// extracted by mini-css-extract-plugin
export default {"PostsControls":"PostsControls_PostsControls__etuNb","PostsControls__Actions":"PostsControls_PostsControls__Actions__FTwyY"};